<template>
      <v-card class="mx-auto content-personal" max-width="80%">
        <user-policy></user-policy>

      </v-card>
</template>
<script>
import UserPolicy from '../components/Common/UserPolicy.vue';

export default {
  name: 'Policy',
 
  data: () => ({}),
  components: {
    UserPolicy,
  },

};
</script>
